/**
 * Created by Amit
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";

require("pixi-particles");

export class PPFreespinAmbientParticles extends BaseView {

    private readonly _screenHeightRange:[number, number] = [720, 1760];
    private readonly _startSpeedRange:[number, number] = [650, 950];
    private _emitter:Emitter;
    private readonly _particleConfig:any = {
        "alpha" : {
            "start" : 0,
            "end" : 1
        },
        "scale" : {
            "start" : .7,
            "end" : 0.1,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#f29100"
        },
        "speed" : {
            "start" : 0,
            "end" : 0,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 4,
            "y" : -8
        },
        "maxSpeed" : 12,
        "startRotation" : {
            "min" : 50,
            "max" : 70
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -194,
            "max" : 192
        },
        "lifetime" : {
            "min" : 3,
            "max" : 5
        },
        "blendMode" : "add",
        "ease" : [
            {
                "s" : 0,
                "cp" : 0.379,
                "e" : 0.548
            },
            {
                "s" : 0.548,
                "cp" : 0.717,
                "e" : 0.676
            },
            {
                "s" : 0.676,
                "cp" : 0.635,
                "e" : 1
            }
        ],
        "frequency" : 0.008,
        "emitterLifetime" : -1,
        "maxParticles" : 50,
        "pos" : {
            "x" : 0,
            "y" : 0,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : GameConfig.instance.GAME_WIDTH,
            "h" : GameConfig.instance.GAME_HEIGHT
        }
    };

    private _layer:ScalableLayer;
    private _isPlaying:boolean = false;

    constructor(layer:ScalableLayer) {
        super();
        this._layer = layer;
    }

    protected initAnimations():void {
        this._emitter = new Emitter(this._layer, [{
            framerate : 30,
            loop : true,
            hasLoaded : true,
            textures : GameResources.getTextures("glowdust")
        }], this._particleConfig);
        this._emitter.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(this._emitter, false);
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        const screenWidth:number = this._resizeData.width / this._layer.scale.x;
        const screenHeight:number = this._resizeData.height / this._layer.scale.y;
        const xPos:number = this._layer.x / this._layer.scale.x;
        const yPos:number = this._layer.y / this._layer.scale.y;
        this._emitter.spawnRect.x = -xPos;
        this._emitter.spawnRect.y = -yPos;
        this._emitter.spawnRect.width = screenWidth;
        this._emitter.spawnRect.height = screenHeight;

        this._isResizeDirty = false;
    }

    public startAnimation():void {
        this.onResize(this._resizeData);
        this._emitter.emit = true;
        this._isPlaying = true;
    }

    public stopAnimation():void {
        this._emitter.cleanup();
        this._isPlaying = false;
        this._emitter.emit = false;
    }
}